export default "__VITE_ASSET__BcKE1F2k__"